import { render, staticRenderFns } from "./CaixaResumo.vue?vue&type=template&id=8f011af8&scoped=true"
import script from "./CaixaResumo.vue?vue&type=script&lang=js"
export * from "./CaixaResumo.vue?vue&type=script&lang=js"
import style0 from "./CaixaResumo.vue?vue&type=style&index=0&id=8f011af8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f011af8",
  null
  
)

export default component.exports